<div class="fileUpload" [ngClass]="disabled ? 'disabled' : ''">
    <input (change)="emitFile($event.target.files)"
           [accept]="[acceptedFileTypes.join(','), acceptedFileExtensions.join(',')].join(',')"
           [id]="'upload' + id"
           [disabled]="disabled"
           type="file"
           #fileUpload>
    <label [htmlFor]="'upload' + id">
        <i class="fas fa-upload"></i><br/>
        <span [i18n]="labelKey"></span>
    </label>
</div>
